export enum DuplicableElementSubSectionIdEnum {
  "GR-Organisations" = "ORG",
  "GR-LotResult" = "RES",
  "GR-LotTender" = "TEN",
  "GR-TenderingParty" = "TPA",
  "GR-SettledContract" = "CON",
  "GR-Organisations-Section" = "ORG",
  "GR-Organisations-Subsection" = "ORG",
  "GR-LotResult-Section" = "RES",
  "GR-LotTender-Section" = "TEN",
  "GR-TenderingParty-Section" = "TPA",
  "GR-SettledContract-Section" = "CON"
}
